export const config_file_success = 'config_file_success'
export const config_file_failure = 'config_file_failure'

export const subject_file_success = 'subject_file_success'
export const subject_file_failure = 'subject_file_failure'